import React from 'react';
import { TabCheckedProps } from './TabCheckBatteryHealth';
import { Stack, Typography } from '@mui/material';
import color from '@theme/Colors';
import Grid2 from '@mui/material/Unstable_Grid2';
import LoadingTextSkeleton from '@components/skeleton/LoadingTextSkeleton';
import { formatActivateTime } from 'src/helpers';
import { DetailsInformation } from '@pages/cameras/details/components/CameraInformation';
import { uploadModeMapping } from '@pages/cameras/details/components/CaptureManagementMilesightCameraSolar';
import { getValueFromMapping } from '@pages/components';
import { frequencyTimeMapping, postTypeMapping } from '@pages/camerasOverview/configs';

export default function TabCheckSDCard({
    taskItem,
    cameraConfigMonitoring,
    loadingCameraConfigMonitoring,
}: TabCheckedProps) {
    const detailBatteryHealth: DetailsInformation[] = [
        {
            id: 1,
            label: 'Last contract:',
            value: (
                <LoadingTextSkeleton
                    conditions={loadingCameraConfigMonitoring}
                    value={
                        cameraConfigMonitoring?.[0]?.LastContact
                            ? formatActivateTime(cameraConfigMonitoring?.[0]?.LastContact)
                            : '-'
                    }
                    loadingStyle={{
                        width: '80%',
                    }}
                />
            ),
        },
        {
            id: 2,
            label: 'Post type:',
            value: (
                <Typography variant="body1">
                    <LoadingTextSkeleton
                        conditions={loadingCameraConfigMonitoring}
                        value={getValueFromMapping(cameraConfigMonitoring?.[0]?.PostType, postTypeMapping)}
                        loadingStyle={{
                            width: '80%',
                        }}
                    />
                </Typography>
            ),
        },
        {
            id: 3,
            label: 'Capacity (GB):',
            value: (
                <LoadingTextSkeleton
                    conditions={loadingCameraConfigMonitoring}
                    value={
                        cameraConfigMonitoring?.[0]?.CameraSDFreeSpace
                            ? `${cameraConfigMonitoring?.[0]?.CameraSDFreeSpace} GB`
                            : null
                    }
                    loadingStyle={{
                        width: '80%',
                    }}
                />
            ),
        },
        {
            id: 4,
            label: 'Used space (MB):',
            value: (
                <Typography variant="body1">
                    <LoadingTextSkeleton
                        conditions={loadingCameraConfigMonitoring}
                        value={
                            cameraConfigMonitoring?.[0]?.CameraSDUsed
                                ? `${cameraConfigMonitoring?.[0]?.CameraSDUsed * 1024} MB`
                                : null
                        }
                        loadingStyle={{
                            width: '80%',
                        }}
                    />
                </Typography>
            ),
        },
        {
            id: 5,
            label: 'Upload mode:',
            value: (
                <Typography variant="body1">
                    <LoadingTextSkeleton
                        conditions={loadingCameraConfigMonitoring}
                        value={getValueFromMapping(cameraConfigMonitoring?.[0]?.UploadMode, uploadModeMapping)}
                        loadingStyle={{
                            width: '80%',
                        }}
                    />
                </Typography>
            ),
        },
        {
            id: 6,
            label: 'Upload frequency:',
            value: (
                <Typography variant="body1">
                    <LoadingTextSkeleton
                        conditions={loadingCameraConfigMonitoring}
                        value={getValueFromMapping(cameraConfigMonitoring?.[0]?.Frequency, frequencyTimeMapping)}
                        loadingStyle={{
                            width: '80%',
                        }}
                    />
                </Typography>
            ),
        },
        {
            id: 7,
            label: 'Number of photos uploaded today:',
            value: (
                <LoadingTextSkeleton
                    conditions={loadingCameraConfigMonitoring}
                    value={cameraConfigMonitoring?.[0]?.TakenPhotosToday ?? 'N/A'}
                    loadingStyle={{
                        width: '80%',
                    }}
                />
            ),
        },
        {
            id: 7,
            label: 'Images left:',
            value: (
                <LoadingTextSkeleton
                    conditions={loadingCameraConfigMonitoring}
                    value={cameraConfigMonitoring?.[0]?.ImagesLeft ?? 'Not active yet'}
                    loadingStyle={{
                        width: '80%',
                    }}
                />
            ),
        },
    ];

    return (
        <Stack direction={'column'} spacing={3} bgcolor={color.grey100} borderRadius={'8px'} p={2}>
            <Stack direction={'column'} spacing={1}>
                <Typography variant="h6" color={color.success}>
                    Information
                </Typography>
                <Stack
                    width={'100%'}
                    padding={2}
                    bgcolor={color.white}
                    borderRadius={'4px'}
                    sx={{
                        maxHeight: '35vh',
                        overflowY: 'auto',
                        '::-webkit-scrollbar': {
                            width: '4px',
                        },
                    }}
                >
                    <Grid2 container spacing={2}>
                        {detailBatteryHealth.map((item) => (
                            <Grid2 xs={6} key={item.id}>
                                <Stack direction={'column'} spacing={1}>
                                    <Stack
                                        key={item.id}
                                        direction={'row'}
                                        width={'100%'}
                                        justifyContent={'space-between'}
                                    >
                                        <Stack width={'60%'}>
                                            <Typography variant="h6">{item.label}</Typography>
                                        </Stack>
                                        <Stack width={'40%'}>
                                            <Typography variant="body1">{item.value}</Typography>
                                        </Stack>
                                    </Stack>
                                </Stack>
                            </Grid2>
                        ))}
                    </Grid2>
                </Stack>
            </Stack>
        </Stack>
    );
}
